import React from "react";

const TechStartupTemplate = ({ brandName, tagline, logo, colorTheme }) => {
  const colorClasses = {
    blue: "text-blue-600",
    green: "text-green-600",
    purple: "text-purple-600",
    red: "text-red-600",
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header */}
      <header className="p-6 bg-gray-100 shadow flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {logo && <img src={logo} alt="Logo" className="h-12" />}
          <div>
            <h1 className={`text-2xl font-bold ${colorClasses[colorTheme]}`}>
              {brandName || "Startup Name"}
            </h1>
            <p className="text-sm text-gray-600">
              {tagline || "Innovate Your Future"}
            </p>
          </div>
        </div>
        <nav className="hidden md:flex space-x-6 text-gray-700">
          <a href="#features" className="hover:underline">
            Features
          </a>
          <a href="#about" className="hover:underline">
            About
          </a>
          <a href="#pricing" className="hover:underline">
            Pricing
          </a>
          <a href="#contact" className="hover:underline">
            Contact
          </a>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="flex-1 flex flex-col justify-center items-center bg-gradient-to-br from-blue-500 to-indigo-600 text-white py-20">
        <h2 className="text-4xl md:text-6xl font-extrabold drop-shadow-md">
          {brandName || "Startup Name"}
        </h2>
        <p className="mt-4 text-lg bg-white bg-opacity-10 px-6 py-3 rounded">
          {tagline || "Building the future with cutting-edge solutions"}
        </p>
      </section>

      {/* Features Section */}
      <section id="features" className="py-16 px-8 bg-gray-50">
        <h3
          className={`text-3xl font-bold mb-10 text-center ${colorClasses[colorTheme]}`}
        >
          Features
        </h3>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-white p-6 rounded shadow text-center">
            <div className="text-4xl mb-4">🚀</div>
            <h4 className="text-xl font-semibold mb-2">Fast Deployment</h4>
            <p className="text-gray-600">
              Launch your projects quickly and efficiently with our platform.
            </p>
          </div>
          <div className="bg-white p-6 rounded shadow text-center">
            <div className="text-4xl mb-4">🔒</div>
            <h4 className="text-xl font-semibold mb-2">Enterprise Security</h4>
            <p className="text-gray-600">
              Top-tier security solutions to protect your data and systems.
            </p>
          </div>
          <div className="bg-white p-6 rounded shadow text-center">
            <div className="text-4xl mb-4">⚡</div>
            <h4 className="text-xl font-semibold mb-2">High Performance</h4>
            <p className="text-gray-600">
              Blazing fast servers and optimized performance for all users.
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 px-8 text-center">
        <h3 className={`text-3xl font-bold mb-6 ${colorClasses[colorTheme]}`}>
          About Us
        </h3>
        <p className="text-gray-700 max-w-2xl mx-auto">
          Our mission is to empower businesses with powerful digital solutions.
          We believe in technology as a force for good and aim to simplify
          complexity through innovation.
        </p>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-16 px-8 bg-white">
        <h3
          className={`text-3xl font-bold mb-10 text-center ${colorClasses[colorTheme]}`}
        >
          Pricing Plans
        </h3>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="border border-gray-300 p-8 rounded-lg shadow hover:shadow-lg transition">
            <h4 className="text-2xl font-semibold mb-4">Starter</h4>
            <p className="text-4xl font-bold mb-4">$29</p>
            <p className="text-gray-600 mb-6">Basic features for small teams</p>
            <button
              className={`bg-${colorTheme}-600 text-white px-6 py-2 rounded hover:bg-${colorTheme}-700`}
            >
              Choose Plan
            </button>
          </div>
          <div className="border border-gray-300 p-8 rounded-lg shadow-lg bg-gray-100 transform scale-105">
            <h4 className="text-2xl font-semibold mb-4">Pro</h4>
            <p className="text-4xl font-bold mb-4">$59</p>
            <p className="text-gray-600 mb-6">
              Advanced features for growing businesses
            </p>
            <button
              className={`bg-${colorTheme}-600 text-white px-6 py-2 rounded hover:bg-${colorTheme}-700`}
            >
              Choose Plan
            </button>
          </div>
          <div className="border border-gray-300 p-8 rounded-lg shadow hover:shadow-lg transition">
            <h4 className="text-2xl font-semibold mb-4">Enterprise</h4>
            <p className="text-4xl font-bold mb-4">Contact</p>
            <p className="text-gray-600 mb-6">
              Custom solutions for large companies
            </p>
            <button
              className={`bg-${colorTheme}-600 text-white px-6 py-2 rounded hover:bg-${colorTheme}-700`}
            >
              Contact Sales
            </button>
          </div>
        </div>
      </section>

      {/* Contact / Footer */}
      <footer id="contact" className="bg-gray-900 text-white py-8 text-center">
        <p>Get in touch: hello@example.com</p>
        <p className="mt-2">
          &copy; {new Date().getFullYear()} {brandName || "Startup"}. All rights
          reserved.
        </p>
      </footer>
    </div>
  );
};

export default TechStartupTemplate;
